const data = [
  {
    img: "/images/electronic.png",
    goto: "electronics",
    name: "Electronics",
  },
  {
    img: "/images/shoes.png",
    goto: "shoes",
    name: "Shoes",
  },
  {
    img: "/images/tshirts.png",
    goto: "fashon",
    name: "Fashon",
  },
  {
    img: "/images/automobile.png",
    goto: "automobile",
    name: "Automobile",
  },
  {
    img: "/images/sports.png",
    goto: "sports",
    name: "Sports",
  },
  {
    img: "/images/furniture.png",
    ref: "furniture",
    name: "Furniture",
  },
];

export default data